<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-end align-center>
        <v-flex xs12 md2> </v-flex>
        <v-flex xs12 md2>
          <v-menu
            :close-on-content-click="false"
            v-model="menu_month_picker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            :disabled="loading.getList"
          >
            <v-text-field
              slot="activator"
              v-model="chosen_month"
              label="Chọn tháng"
              :disabled="loading.getList"
              prepend-icon="event"
              readonly
              single-line
              hide-details
            ></v-text-field>
            <v-date-picker
              min="2025-01"
              locale="vi-VI"
              type="month"
              v-model="chosen_month"
              @input="menu_month_picker = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>
      <!-- <v-layout row wrap justify-end align-center>
				<v-btn
					:disabled="loading.getList"
					@click="print_list = true"
					color="primary"
				>
					<v-icon small left>print</v-icon>
					In bảng công nợ
				</v-btn>
				<v-btn :loading="export_csv.loading" @click="exportCSV" color="green" class="white--text">XUẤT EXCEL</v-btn>
				<export-csv-button
					:trigger="export_csv.trigger"
					:title="export_csv.title"
					:rows="export_csv.rows"
				></export-csv-button>
			</v-layout> -->
      <v-layout row wrap justify-center>
        <v-flex xs12>
          <v-card>
            <v-data-table
              disable-initial-sort
              :headers="headers"
              :items="items"
              :rows-per-page-items="rowPerPage"
              :loading="loading.getList"
            >
              <template #items="props">
                <template v-if="props.item.isSummaryRow">
                  <tr>
                    <td class="text-center">{{ props.item.type }}</td>
                    <td class="text-center">{{ props.item.account }}</td>
                    <td class="text-center font-weight-bold">
                      {{ props.item.object }}
                    </td>
                    <td class="text-center text-no-wrap font-weight-bold">
                      {{ props.item.opening_balance | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap font-weight-bold">
                      {{ props.item.increase | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap font-weight-bold">
                      {{ props.item.decrease | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap font-weight-bold">
                      {{ props.item.end_balance | formatNumber }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="props.item.is_loan_section_summary">
                  <tr style="background: aliceblue;">
                    <td class="text-center">{{ props.item.type }}</td>
                    <td class="text-center">{{ props.item.account }}</td>
                    <td class="text-center">{{ props.item.object }}</td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.opening_balance | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.increase | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.decrease | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.end_balance | formatNumber }}
                    </td>
                  </tr>
                </template>
				<template v-else>
                  <tr>
                    <td class="text-center">{{ props.item.type }}</td>
                    <td class="text-center">{{ props.item.account }}</td>
                    <td class="text-center">{{ props.item.object }}</td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.opening_balance | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.increase | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.decrease | formatNumber }}
                    </td>
                    <td class="text-center text-no-wrap">
                      {{ props.item.end_balance | formatNumber }}
                    </td>
                  </tr>
                </template>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import api from "Api";
import moment from "moment";
import { buildParamQuery } from "Helpers";
import ExportCsvButton from "Components/ExportExcel/ExportCsvButton";
import PrintPortal from "Components/Print/PrintPortal";

export default {
  name: "bang-tong-hop-cong-no-khac",
  components: {
    ExportCsvButton,
    PrintPortal,
  },
  data() {
    return {
      headers: [
        {
          text: "Phân loại",
          align: "center",
          value: "type",
        },
        {
          text: "Tài khoản",
          align: "center",
          value: "account",
        },
        {
          text: "Đối tượng",
          align: "center",
          value: "object",
        },
        {
          text: "Số dư đầu kỳ (ngày 01/01/2025)",
          align: "center",
          value: "opening_balance",
        },
        {
          text: "Phát sinh tăng",
          align: "center",
          value: "opening_balance",
        },
        {
          text: "Phát sinh giảm",
          align: "center",
          value: "opening_balance",
        },
        {
          text: "Số dư cuối kỳ",
          align: "center",
          value: "end_balance",
        },
      ],
      items: [],
      loading: {
        submit: false,
        getDetail: false,
        getList: false,
      },
      rowPerPage: [{ text: "Tất cả", value: -1 }],
      menu_month_picker: false,
      chosen_month: moment()
        .subtract(1, "months")
        .toISOString()
        .substr(0, 7),
      export_csv: {
        loading: false,
        trigger: false,
        title: "",
        rows: [],
      },
    };
  },
  computed: {
    user_role() {
      return this.$store.state.auth.role;
    },
  },
  watch: {
    chosen_month() {
      this.getTablesData();
    },
  },
  mounted() {
    this.getTablesData();
  },
  methods: {
    getTablesData: async function() {
      this.loading.getList = true;
      const last_date_of_month = this.getLastDateOfChosenMonth(
        this.chosen_month
      );
      const params = {
        lastDateOfMonth: last_date_of_month
          .clone()
          .endOf("month")
          .toISOString(),
      };
      const query = buildParamQuery(params);

      try {
        const [loan_data, mrs_gam_debt_data] = await Promise.all([
          api.getLoanDebtReport(query),
          api.getMrsGamDebtReport(query),
        ]);

        const cloneData = [...loan_data.data];
        const loan_total_row = {
          ...cloneData[cloneData.length - 1],
          isSummaryRow: true,
        };
        const mrs_gam_receivable__total_row = {
          ...mrs_gam_debt_data.data,
          type: undefined,
          account: undefined,
          object: "Tổng",
          isSummaryRow: true,
        };
        this.items = [
          { ...mrs_gam_debt_data.data, category: "mrs_gam_receivable" },
          mrs_gam_receivable__total_row,
          ...cloneData.slice(0, cloneData.length - 1).map((e) => {
            return { ...e, category: "loan" };
          }),
          loan_total_row,
        ];
      } catch (error) {
        console.log("🚀 ~ getTablesData:function ~ error:", error.m);
      } finally {
		this.headers[this.headers.length - 1].text = `Số dư cuối kỳ (ngày ${last_date_of_month.format("DD/MM/YYYY").substr(0, 10)})`;
        this.loading.getList = false;
      }
    },

    getLastDateOfChosenMonth(chosen_month) {
      const start_date = new Date(chosen_month + "-01");
      return moment(start_date).endOf("month");
    },
    exportCSV: function() {
      const rows = this.items.map((item) => {
        return {
          "Phân loại": item.type,
          "Tài khoản": item.account,
          "Đối tượng": item.object,
          "Số dư đầu kỳ": item.opening_balance,
          "Phát sinh tăng": item.increase,
          "Phát sinh giảm": item.decrease,
          "Số dư cuối kỳ": item.end_balance,
        };
      });
      rows.unshift({
        "Phân loại": this.summaryRow.type,
        "Tài khoản": this.summaryRow.account,
        "Đối tượng": this.summaryRow.object,
        "Số dư đầu kỳ": this.summaryRow.opening_balance,
        "Phát sinh tăng": this.summaryRow.increase,
        "Phát sinh giảm": this.summaryRow.decrease,
        "Số dư cuối kỳ": this.summaryRow.end_balance,
      });
      this.export_csv.rows = rows;
      this.export_csv.title = "bang-cong-no-thang-" + this.chosen_month;
      this.export_csv.trigger = !this.export_csv.trigger;
    },
  },
};
</script>
